import { cityAliases } from './constants';

export function getUserCity(pathname: string): string {
  return pathname.split('/').find(segment => cityAliases.has(segment)) || 'unknown';
}
